import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const Navbar = ({ scrollToSection, toggleTheme, theme }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate(); // Tambahkan ini

  const menuItems = [
    { id: 'hero', label: 'Home', icon: 'fas fa-home' },
    { id: 'requirements', label: 'Requirements', icon: 'fas fa-list-check' },
    { id: 'levels', label: 'Levels', icon: 'fas fa-chart-line' },
    { id: 'share-gift', label: 'Share Gift', icon: 'fas fa-gift' },
    { id: 'share-section', label: 'Share', icon: 'fas fa-share' },
    { id: 'contact', label: 'Contact', icon: 'fas fa-envelope' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMenuItemClick = (sectionId) => {
    scrollToSection(sectionId);
    setIsMobileMenuOpen(false);
  };

  const handleContactClick = () => {
    window.open('https://wa.me/62811248168', '_blank');
  };

  // Fungsi untuk navigasi ke halaman profile
  const handleProfileClick = () => {
    navigate('/profile'); // Arahkan ke halaman profile
    setIsMobileMenuOpen(false); // Tutup menu mobile jika terbuka
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="navbar-content">
          {/* Logo */}
          <div className="navbar-logo" onClick={() => scrollToSection('hero')}>
            <div className="logo-icon">
              <i className="fas fa-crown"></i>
            </div>
            <div className="logo-text">
              <span className="logo-primary">CROWN</span>
              <span className="logo-secondary">MANAGEMENT</span>
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="navbar-menu desktop-menu">
            {menuItems.map((item) => (
              <button
                key={item.id}
                className="nav-item"
                onClick={() => handleMenuItemClick(item.id)}
                aria-label={`Go to ${item.label}`}
              >
                <i className={item.icon}></i>
                <span>{item.label}</span>
              </button>
            ))}
            
            {/* Profile Button - Desktop */}
            <button 
              className="nav-item"
              onClick={handleProfileClick}
              aria-label="View Host Profiles"
            >
              <i className="fas fa-user-circle"></i>
              <span>Profile Host</span>
            </button>
            
            {/* Desktop Theme Toggle */}
            <button 
              className="nav-item"
              onClick={toggleTheme}
              aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
            >
              <i className={theme === 'dark' ? 'fas fa-sun' : 'fas fa-moon'}></i>
              <span>Setting Tema</span>
            </button>
            
            <button 
              className="nav-item nav-cta"
              onClick={handleContactClick}
              aria-label="Contact us on WhatsApp"
            >
              <i className="fab fa-whatsapp"></i>
              <span>Contact Us</span>
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button 
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
            aria-expanded={isMobileMenuOpen}
          >
            <span className={`bar ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`bar ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`bar ${isMobileMenuOpen ? 'open' : ''}`}></span>
          </button>

          {/* Mobile Menu Overlay */}
          <div 
            className={`mobile-menu-overlay ${isMobileMenuOpen ? 'open' : ''}`}
            onClick={() => setIsMobileMenuOpen(false)}
          />

          {/* Mobile Menu */}
          <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
            <div className="mobile-menu-header">
              <div className="mobile-logo">
                <i className="fas fa-crown"></i>
                <span>CROWN MANAGEMENT</span>
              </div>
              <button 
                className="mobile-menu-close"
                onClick={() => setIsMobileMenuOpen(false)}
                aria-label="Close menu"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            
            <div className="mobile-menu-items">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  className="mobile-nav-item"
                  onClick={() => handleMenuItemClick(item.id)}
                >
                  <i className={item.icon}></i>
                  <span>{item.label}</span>
                </button>
              ))}
              
              {/* Profile Button - Mobile */}
              <button 
                className="mobile-nav-item"
                onClick={handleProfileClick}
              >
                <i className="fas fa-user-circle"></i>
                <span>Profile Host</span>
              </button>
              
              {/* Mobile Theme Toggle */}
              <button 
                className="mobile-nav-item"
                onClick={toggleTheme}
              >
                <i className={theme === 'dark' ? 'fas fa-sun' : 'fas fa-moon'}></i>
                <span>Setting Tema: {theme === 'dark' ? 'Terang' : 'Gelap'}</span>
              </button>
              
              <button 
                className="mobile-nav-item mobile-nav-cta"
                onClick={handleContactClick}
              >
                <i className="fab fa-whatsapp"></i>
                <span>Contact Us</span>
              </button>
            </div>

            <div className="mobile-menu-footer">
              <div className="mobile-social-links">
                <a href="https://wa.me/62811248168" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-whatsapp"></i>
                </a>
                <a href="mailto:crownmanagement44@gmail.com" target="_blank" rel="noreferrer">
                  <i className="fa-solid fa-envelope"></i>
                </a>
                <a href="https://www.instagram.com/crown.management.id/" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
              <p className="mobile-copyright">© 2026 CROWN MANAGEMENT</p>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
